import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";

export default function AuthAlert({ alertType, message, onDeactivate, onReauthorize }) {
  return (
    <div data-attr="fb_auth_alert" className={classNames('alert', `alert-${alertType}`)}>
      <p>{message}</p>
      <p>Please <a href="#" data-test-id="reauthorize" onClick={onReauthorize}>re-authorize</a> to correct the authentication issues or <a data-test-id="deactivate" href="#" onClick={onDeactivate}>deactivate</a> to remove the integration.</p>
    </div>
  );
}

AuthAlert.propTypes = {
  alertType: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  onReauthorize: PropTypes.func.isRequired
};
